import script from "./AnnualLeaveBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualLeaveBalance.vue?vue&type=script&setup=true&lang=js"

import "./AnnualLeaveBalance.vue?vue&type=style&index=0&id=264671e2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264671e2"]])

export default __exports__